import clsx from 'clsx';

import {
  type DataTestId,
  type StylingProps,
  type WithChildren,
} from '@dynatrace/strato-components/core';
import { _textStyleCSS as textStyleCSS } from '@dynatrace/strato-components/styles';
import { Text } from '@dynatrace/strato-components/typography';

import { suggestionGroupLabelCSS } from './SuggestionGroupLabel.sty.js';

/**
 * Accepted properties for the FilterField suggestion group label.
 * @public
 */
export type FilterFieldSuggestionGroupLabelProps = WithChildren &
  StylingProps &
  DataTestId;

/**
 * @public
 */
export const SuggestionGroupLabel = (
  props: FilterFieldSuggestionGroupLabelProps,
) => {
  const {
    children,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
  } = props;

  return (
    <Text
      textStyle="base"
      data-testid={dataTestId}
      className={clsx(
        suggestionGroupLabelCSS,
        consumerClassName,
        textStyleCSS({ textStyle: 'small-emphasized' }),
      )}
      style={consumerStyle}
      as="p"
    >
      {children}
    </Text>
  );
};

SuggestionGroupLabel.displayValue = 'FilterField.SuggestionGroupLabel';
